//IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logo from "../assets/images/widepack-logo-swirl-slogan-large.png";

import "../scss/Home.scss";

export const Home = () => {
  //
  const { t } = useTranslation();

  return (
    <main className='home'>
      <div className='container'>
        <section style={{ flexDirection: "column" }}>
          <img
            style={{ marginTop: 100 }}
            src={logo}
            alt='Widepack Logo swirl'
          />
          <div className='content'>
            <p>{t("home:p1")}</p>
            <p>{t("home:p2")}</p>
            <p>{t("home:p3")}</p>
            <p>{t("home:p4")}</p>
            <p>{t("home:p5")}</p>
          </div>
          <Link to='/contact' className='button'>
            <button className='float btn btn-fern rad-shadow'>
              {t("home:cta")}
            </button>
          </Link>
        </section>
      </div>
    </main>
  );
};
